import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import { CaretLeft, Heart } from '@phosphor-icons/react';

export default function LegalPageLayout({ title, lastUpdated, children, testId }) {
  return (
    <div className="min-h-screen bg-surface-secondary" data-testid={testId}>
      <Navbar />
      <div className="pt-24 pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-1 text-sm text-primary hover:underline mb-4"
            data-testid="legal-back-home"
          >
            <CaretLeft size={16} weight="bold" />
            Back to Home
          </Link>
          <div className="card">
            <div className="border-b border-primary/10 pb-6 mb-6">
              <h1 className="font-spectral text-3xl sm:text-4xl font-bold text-primary mb-2">{title}</h1>
              {lastUpdated && (
                <p className="text-sm text-secondary">Last updated: {lastUpdated}</p>
              )}
            </div>
            <div className="legal-content space-y-4 text-secondary leading-relaxed">
              {children}
            </div>
            <div className="border-t border-primary/10 mt-8 pt-6 text-sm text-secondary">
              Questions about this page? Email{' '}
              <a href="mailto:support@seconddoctoropinion.com" className="text-primary font-semibold hover:underline">
                support@seconddoctoropinion.com
              </a>{' '}
              or WhatsApp{' '}
              <a href="https://wa.me/918840804798" className="text-primary font-semibold hover:underline">
                +91 88408 04798
              </a>.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Helper styled components for legal pages
export const H2 = ({ children }) => (
  <h2 className="font-manrope text-xl font-bold text-primary mt-8 mb-3">{children}</h2>
);

export const H3 = ({ children }) => (
  <h3 className="font-manrope text-base font-semibold text-primary mt-4 mb-2">{children}</h3>
);

export const P = ({ children }) => (
  <p className="text-secondary leading-relaxed">{children}</p>
);

export const UL = ({ children }) => (
  <ul className="list-disc pl-6 space-y-2 text-secondary">{children}</ul>
);
